module.exports = __webpack_public_path__ + "img/trolley-ecg.4923ad6d.png";